<template>
  <div class="contact-button-component">
    <VDialog v-model="showModal" maxWidth="30%">
      <VCard>
        <VCardTitle class="headline pb-0">
          <b>Send Inquiry</b>
        </VCardTitle>
        <VCardText>
          <p class="subheading">
            <b>Hi {{ user.username }}</b
            >! <br />Thank you for your interest on PM2 Enterprise. To know more about our offer,
            please reach out to us with this contact form. We will then come back to you shortly.<br />
          </p>
          <h2 class="pb-2">Contact form</h2>
          <VForm ref="form" v-model="valid">
            <VTextField v-model="email" label="Email" type="email" :rules="emailRules" />
            <VTextField v-model="fullname" label="Full Name" :rules="nameRules" />
            <VTextField v-model="phone" label="Phone number" type="phone" />
            <VTextField
              v-model="processes"
              label="Process Monitored"
              type="number"
              hint="Number of individual processes/instances of Node.js you plan to monitor."
            />
            <VTextarea
              v-model="comments"
              required
              placeholder="Type your comment here"
              name="input-7-1"
              label="A little bit more about your usecase"
            />
          </VForm>
        </VCardText>

        <Center>
          <VBtn color="success darken-1" :disabled="!valid" class="mb-4" @click="submit">
            Send Inquiry
          </VBtn>
        </Center>
      </VCard>
    </VDialog>
    <div>
      <VBtn
        :color="color"
        class="contact-button font-bold ma-0"
        :small="small"
        @click="showModal = true"
      >
        <VIcon v-if="!small" class="mr-2">
          mdi-email-outline
        </VIcon>
        Contact us
      </VBtn>
    </div>
  </div>
</template>

<script>
import { SUBMIT_CONTACT_INFOS } from '@/store/actions'

export default {
  name: 'ContactButton',

  props: {
    color: {
      type: String,
      default: 'primary',
    },
    small: Boolean,
  },

  data() {
    const user = this.$store.state.user
    return {
      email: user.email,
      emailRules: [
        value => {
          if (value && value.length > 0) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
          return 'You need to fill your email'
        },
      ],
      nameRules: [v => v.length > 0 || 'You need to fill your name'],
      fullname: user.username,
      phone: '',
      processes: 0,
      comments: '',
      showModal: false,
      valid: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters.user
    },
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        this.$store
          .dispatch(SUBMIT_CONTACT_INFOS, {
            email: this.email,
            fullname: this.fullname,
            phone: this.phone,
            processes: this.processes,
            comments: this.comments,
          })
          .then(res => {
            this.$store.dispatch('DISPLAY_NOTIFICATION', {
              message: 'Contact request sent, we will come back to you shortly.',
              type: 'success',
            })
            this.showModal = false
            this.comments = ''
            this.fullname = ''
            this.email = ''
            this.phone = ''
            this.processes = 0
          })
          .catch(err => {
            console.error(err)
            this.$store.dispatch('DISPLAY_NOTIFICATION', {
              message: 'Use sales@pm2.io to contact us',
              type: 'error',
            })
          })
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.contact-button-component {
  display: inline-block;
  & .contact-button {
    width: 100%;
  }
}
</style>
